//@ts-ignore
import config from "config";

const makeContactUsLink = (text: string, path: string) => {
  const contactUsLink =
    //@ts-ignore
    config.baseurl + path + "contact-us?subject=payments";
  return text.replace("#contact-us-sales#", contactUsLink);
};

export default makeContactUsLink;
